<template>
  <v-dialog max-width="600px" v-model="dialogModel">
    <v-card>
      <v-card-title class="headline">
        <span v-if="isEdit">{{ $t('message.editDealer') }}</span>
        <span v-else-if="isCreate">{{ $t('message.addDealer') }}</span>
        <span v-else>{{ $t('message.dealerDetails') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="form.valid">
          <v-container grid-list-md pt-0>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  :label="$t('message.name')"
                  data-vv-name="name"
                  prepend-icon="label"
                  :error-messages="errors.collect('name')"
                  v-validate="formValidation.name"
                  v-model="form.name"
                  :readonly="isView"
                  type="text"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  :label="$t('message.lastname')"
                  data-vv-name="lastname"
                  prepend-icon="label"
                  :error-messages="errors.collect('lastname')"
                  v-validate="formValidation.lastname"
                  v-model="form.lastname"
                  :readonly="isView"
                  type="text"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  :label="$t('message.telephone')"
                  data-vv-name="phone"
                  prepend-icon="zmdi-phone"
                  :error-messages="errors.collect('phone')"
                  v-validate="formValidation.phone"
                  v-model="form.phone"
                  :readonly="isView"
                  type="tel"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  :label="$t('message.identification')"
                  data-vv-name="identification"
                  prepend-icon="zmdi-face"
                  :error-messages="errors.collect('identification')"
                  v-validate="formValidation.identification"
                  v-model="form.identification"
                  :readonly="isView"
                ></v-text-field>
              </v-flex>

              <!-- <v-flex xs12>
                <v-text-field
                  :label="$t('message.bankName')"
                  data-vv-name="bankName"
                  prepend-icon="zmdi-balance"
                  :error-messages="errors.collect('bankName')"
                  v-validate="formValidation.bank_account"
                  v-model="form.bank_account"
                  :readonly="isView"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  :label="$t('message.accountNumber')"
                  data-vv-name="accountNumber"
                  prepend-icon="zmdi-balance"
                  :error-messages="errors.collect('accountNumber')"
                  v-validate="formValidation.account_number"
                  v-model="form.account_number"
                  :readonly="isView"
                ></v-text-field>
              </v-flex> -->

              <v-flex xs12>
                <v-text-field
                  :label="$t('message.telegramUser')"
                  data-vv-name="telegramUser"
                  prepend-icon="zmdi-account"
                  :error-messages="errors.collect('telegramUser')"
                  v-validate="formValidation.telegram_user"
                  v-model="form.telegram_user"
                  :readonly="isView"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 v-if="isView">
                <v-text-field
                  :label="$t('message.privateKey')"
                  prepend-icon="zmdi-key"
                  v-model="form.privateKey"
                  :readonly="isView"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline @click="onClose" color="error" small>{{ $t('message.close') }}</v-btn>
        <v-btn outline @click="onSave" v-if="!isView" color="primary" small>{{ $t('message.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

const initForm = {
  name: "",
  lastname: "",
  phone: "",
  // account_number: "",
  // // bank_account: "",
  identification: "",
  telegram_user: "",
  privateKey: null,
  valid: false
};

export default {
  name: "deliveryManage",
  props: {
    dialog: {
      required: false,
      default: false
    },
    isEdit: {
      required: false,
      default: false
    },
    isCreate: {
      required: false,
      default: false
    },
    isView: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      form: initForm,
      formValidation: {
        name: "required|alpha_spaces|min:2|max:50",
        lastname: "required|alpha_spaces|min:2|max:50",
        phone: "required|numeric|min:11,max:11",
        // account_number: "required|numeric|min:11|max:20",
        // bank_account: "required|alpha_spaces|min:2|max:50",
        identification: "required|numeric",
        telegram_user: "required|alpha_num"
      },
      dialogModel: this.dialog
    };
  },
  methods: {
    resetForm() {
      this.form = initForm;
      this.$validator.reset();
      this.$refs.form.reset();
    },
    onClose() {
      this.$emit("update:dialog", false);
      this.resetForm();
    },
    setValue(element) {
      this.form.name = element.name;
      this.form.lastname = element.lastname;
      this.form.phone = element.phone;
      // this.form.bank_account = element.bank_account;
      // this.form.account_number = element.account_number;
      this.form.identification = element.identification;
      this.form.telegram_user = element.telegram_user;
      this.form.privateKey = element.private_key;
    },
    async onSave() {
      try {
        const valid = await this.$validator.validateAll();
        if (valid) {
          this.$emit("on-save", this.form);
          this.$emit("update:dialog", false);
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
  watch: {
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit("update:dialog", value);
    }
  }
};
</script>

<style>
</style>
